import React, { useState, useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  DialogComponent,
  AutocompleteComponent,
  Spinner,
  DataFileAutocompleteComponent,
} from '../../../../../../../Components';
import {
  GetContacts,
  GetAllContactRelationships,
  CreateAssociatedContact,
  UpdateAssociatedContact,
} from '../../../../../../../Services';
import { showError, showSuccess, GetParams } from '../../../../../../../Helper';

export const AssociatedDiloag = ({
  openAddDialog,
  t,
  translationPath,
  parentTranslationPath,
  setFilter,
  setOpenAddDialog,
  filter,
  activeItem,
  reloadData,
  allAssociated,
}) => {
  
  const searchTimer = useRef(null);
  const [loading, setLoading] = useState(false);
  const [saveIsDisabled, setSaveIsDisabled] = useState(true);
  const [associatedContactData, setAssociatedContactData] = useState([]);
  const [selectedAssociatedContact, setSelectedAssociatedContact] =
    useState(null);
  const [selectedRelationship, setSelectedRelationship] = useState(null);
  
  const [relationshipData, setRelationshipData] = useState([]);

  const saveHandler = useCallback(
    async (e) => {
      e.preventDefault();
      setLoading(true);

      const isEditMode = Boolean(activeItem?.associatedContactId);
      const payload = {
        contactId: GetParams('id'),
        contactRelationshipId: selectedRelationship?.contactRelationshipId,
        relatedAssociatedContactsId:
          selectedAssociatedContact?.relatedAssociatedContactsId ||
          selectedAssociatedContact?.contactsId,
      };

      try {
        const res = isEditMode
          ? await UpdateAssociatedContact(
              payload,
              activeItem.associatedContactId
            )
          : await CreateAssociatedContact(payload);

        const isSuccess = !(res && res.status && res.status !== 200);
        

        
        if (isSuccess) {
          const successMessageKey = isEditMode
            ? 'edit-associated-successfully'
            : 'add-associated-successfully';
          showSuccess(t(`${translationPath}${successMessageKey}`));
        } else if (res?.data?.Message?.includes('Holding Company')) {
          const cleanMessage = res.data.Message.split(' : ')[1];
          showError(cleanMessage);
        } else {
          const errorMessageKey = isEditMode
            ? 'edit-associated-failed'
            : 'add-associated-failed';
          showError(t(`${translationPath}${errorMessageKey}`));
        }
      } catch (err) {
        showError(t(`${translationPath}add-associated-failed`));
      } finally {
        reloadData();
        setLoading(false);
        setSaveIsDisabled(true);
        setOpenAddDialog(false);
      }
    },
    [
      activeItem,
      selectedRelationship,
      selectedAssociatedContact,
      translationPath,
      reloadData,
    ]
  );

  const searchHandler = (e) => {
    const { value } = e.target;
    if (searchTimer.current) {
      clearTimeout(searchTimer.current);
    }
    searchTimer.current = setTimeout(() => {
      setFilter((f) => ({ ...f, search: value }));
    }, 700);
  };
  const getAllAssociatedContact = useCallback(async () => {
    setLoading(true);
    let res = await GetContacts({
      ...filter,
      search: filter.search,
      isAdvance: false,
      // contactsType: GetParams('formType'),
    });
    if (!(res && res.status && res.status !== 200)) {
      let filterAssociated = res.result.filter(
        (el) =>
          allAssociated.findIndex(
            (item) => item.relatedAssociatedContactsId === el.contactsId
          ) === -1
      );
      setAssociatedContactData(filterAssociated);
    } else setAssociatedContactData(null);
    setLoading(false);
  }, [filter]);

  const getAllContactRelationships = useCallback(async () => {
    setLoading(true);
    const res = await GetAllContactRelationships(GetParams('formType'));
    if (!(res && res.status && res.status !== 200)) setRelationshipData(res);
    else setRelationshipData([]);
    setLoading(false);
  }, []);

  useEffect(() => {
    getAllAssociatedContact();
  }, [filter]);

  useEffect(() => {
    getAllContactRelationships();
  }, []);

  useEffect(() => {
    if (selectedRelationship && selectedAssociatedContact)
      setSaveIsDisabled(false);
    else setSaveIsDisabled(true);
  }, [selectedRelationship, selectedAssociatedContact]);

  useEffect(() => {
    if (activeItem) {
      setSelectedRelationship(activeItem);
      setSelectedAssociatedContact(activeItem);
    }
  }, []);
  const getContactLabel = (option) => {
    if (option.relatedContactName) return option.relatedContactName;

    const { contact } = option || {};
    if (!contact) return '';

    return contact.contact_type_id === 2
      ? contact.company_name
      : `${contact.first_name} ${contact.last_name}`;
  };

  return (
    <>
      <Spinner isActive={loading} />
      <div className='add-view-wrapper d-flex'>
        <DialogComponent
          isOpen={openAddDialog}
          translationPath={translationPath}
          parentTranslationPath={parentTranslationPath}
          titleText={(activeItem && 'edit-associated') || 'add-associated'}
          maxWidth='sm'
          onSaveClicked={saveHandler}
          saveText={(activeItem && 'edit-associated') || 'add-associated'}
          onCancelClicked={() => setOpenAddDialog(false)}
          disableBackdropClick
          saveIsDisabled={saveIsDisabled}
          dialogContent={
            <>
              <div className='add-content'>
                <div className='auto-wrapper'>
                  <div className='mb-3'>
                    <DataFileAutocompleteComponent
                      idRef='associatedContactRef'
                      labelValue='associatedContact'
                      multiple={false}
                      data={associatedContactData || []}
                      withoutSearchButton
                      selectedValues={selectedAssociatedContact}
                      isLoading={loading}
                      chipsLabel={getContactLabel}
                      displayLabel={getContactLabel}
                      filterOptions={(options) => {
                        return options.filter(
                          (el) => parseInt(GetParams('id')) !== el.contactsId
                        );
                      }}
                      onInputKeyUp={searchHandler}
                      onChange={(event, newInput) => {
                        setSelectedAssociatedContact(newInput);
                      }}
                      translationPath={translationPath}
                      parentTranslationPath={parentTranslationPath}
                    />
                  </div>
                  <AutocompleteComponent
                    idRef='relationshipRef'
                    labelValue='relationship'
                    multiple={false}
                    selectedValues={selectedRelationship}
                    data={relationshipData || []}
                    withoutSearchButton
                    chipsLabel={(option) => option?.contactRelationshipName}
                    displayLabel={(option) => option?.contactRelationshipName}
                    isLoading={loading}
                    onChange={(_, newInput) => {
                      
                      setSelectedRelationship(newInput);
                    }}
                    translationPath={translationPath}
                    parentTranslationPath={parentTranslationPath}
                  />
                </div>
              </div>
            </>
          }
        />
      </div>
    </>
  );
};

AssociatedDiloag.prototype = {
  parentTranslationPath: PropTypes.string.isRequired,
  translationPath: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  setFilter: PropTypes.func.isRequired,
  setOpenAddDialog: PropTypes.func.isRequired,
  openAddDialog: PropTypes.bool.isRequired,
};
